import React, { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { AutocompleteSync } from 'components/Form';
import { DEFAULT_LANGUAGE } from 'constants/language';
import useCountry from 'hooks/language/useCountry';
import useSanctionedCountryCodes from 'hooks/configurations/useSanctionedCountryCodes';
export default function FormCountrySelector({
  control,
  name,
  label,
  excludeCodes
}) {
  const {
    countryList,
    getChosenCountryObject
  } = useCountry();
  const {
    defaultValuesRef: {
      current
    }
  } = control;
  const currentCountryCode = current.countryCode ?? current.nationality;
  const {
    sanctionedCodes,
    loading: sanctionedLoading,
    error: sanctionedError
  } = useSanctionedCountryCodes();
  const availableCountries = useMemo(() => {
    const countries = countryList ?? [];
    const explicitExcludes = new Set((excludeCodes ?? []).filter(code => code !== undefined));
    return countries.filter(country => {
      const code = String(country.code);
      if (explicitExcludes.has(code)) return false;
      if (sanctionedCodes.has(code)) return false;
      return true;
    });
  }, [countryList, excludeCodes, sanctionedCodes]);
  const isBlockedBySanctionedState = sanctionedLoading || sanctionedError;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    rules: {
      required: true
    },
    defaultValue: currentCountryCode ?? DEFAULT_LANGUAGE,
    render: ({
      name: inputName,
      onChange
    }) => /*#__PURE__*/React.createElement(AutocompleteSync, {
      getOptionSelected: true,
      label: label,
      options: availableCountries,
      onChange: country => onChange(country?.code || ''),
      name: inputName,
      optionLabel: "name",
      defaultValue: getChosenCountryObject(currentCountryCode || DEFAULT_LANGUAGE),
      disabled: isBlockedBySanctionedState
    })
  });
}